import type { CompositionIssue } from './composition-issue';

export function CompositionIssueNotice({ issue, onShow, onRepair }: { issue: CompositionIssue | undefined; onShow: () => void; onRepair: () => void }) {
  if (!issue) return null;
  return <section className="composition-issue" aria-label="Composition needs attention">
    <h2>{issue.title}</h2><p>{issue.message}</p>
    <div><button className="secondary" onClick={onShow}>Show in preview</button><button className="primary" onClick={onRepair}>{issue.action}</button></div>
  </section>;
}
